export default function syncableSectionTitleChangeDirective() {
  return {
    template: require('./syncable-section-title-change.html'),
    restrict: 'E',
    controller: 'SyncableSectionTitleChangeController',
    controllerAs: 'syncableSectionTitleChangeVM',
    bindToController: true,
    replace: true,
    scope: {
      change: '=',
      isNew: '=',
      ssTooltipAppendToSelector: '@',
      handleApproveChangeClick: '&',
      handleDenyChangeClick: '&',
      isBatch: '=',
    },
  };
}
